<template>
  <div>
    <v-row
      id="webinar-section-1"
      :class="
        sessionDetails.status == 'Published' || sessionDetails.status == 'Draft'
          ? 'pending-webinar-section ma-0'
          : 'ma-0'
      "
      style="position:relative;"
    >
      <div
        style="position:absolute; width:100%; height:90%; background: linear-gradient(159.3deg, #506CFF -6.17%, #50CAFF 99.39%), #FFFFFF;box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.12);"
      />
      <v-container style="z-index: 1;">
        <v-row class="ma-0">
          <v-col cols="12" sm="7" class="px-0 pe-sm-4">
            <v-col
              class="px-0 pb-0"
              style="font-weight: normal;font-size: 18px;line-height: 25px;color: rgba(255, 255, 255, 0.87);"
            >
              Eblity Webinar series
            </v-col>
            <v-col
              class="px-0"
              style="font-weight: 800;font-size: 30px;line-height: 41px;color: #FFFFFF;"
            >
              {{ sessionDetails.title }}
            </v-col>
            <v-col
              class="pa-0"
              style="font-weight: 800;font-size: 20px;line-height: 27px;color: rgba(255, 255, 255, 0.87);"
            >
              {{ sessionDetails.subTitle }}
            </v-col>

            <v-col
              v-if="
                sessionDetails.status != 'Published' &&
                  sessionDetails.status != 'Draft'
              "
              class="pa-0 mt-4"
              style="font-weight: normal;font-size: 14px;line-height: 19px;color: rgba(255, 255, 255, 0.6);"
            >
              by {{ sessionDetails.speaker_details.educatorName }}
            </v-col>
            <v-divider
              v-else
              class="my-7"
              style="border-color: rgba(255, 255, 255, 0.16)!important;"
            />
            <WebinarTakeAway
              v-if="
                sessionDetails.status == 'Published' ||
                  sessionDetails.status == 'Draft'
              "
              :takeAway="sessionDetails.take_away"
              :dark="true"
            />
            <v-col
              class="pa-0 mt-10"
              v-else-if="sessionDetails.status != 'On-Demand'"
            >
              <v-col
                class="pa-0"
                style="font-weight: 800;font-size: 22px;line-height: 30px;color: #FFDC73;"
              >
                {{ sessionDetails.date }}, {{ sessionDetails.day }}
              </v-col>
              <v-col
                class="pa-0 mt-4"
                style="font-weight: 800;font-size: 20px;line-height: 27px;color: #FFE597;"
              >
                {{ sessionDetails.time }}
              </v-col>
            </v-col>
            <v-col
              class="pa-0 mt-10"
              v-else-if="sessionDetails.status == 'On-Demand'"
            >
              <v-col
                class="pa-0"
                style="font-weight: 800;font-size: 22px;line-height: 30px;color: #FFDC73;"
              >
                Available On-Demand
              </v-col>
            </v-col>
          </v-col>
          <v-col class="pb-0">
            <RegisterLoginCard
              :sessionDetails="sessionDetails"
              :sessionObject="details"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <div
      id="webinar-section-2"
      :class="
        sessionDetails.status == 'Published' || sessionDetails.status == 'Draft'
          ? 'pending-webinar-section'
          : ''
      "
    >
      <v-container>
        <v-row class="ma-0">
          <v-col cols="12" sm="8">
            <WebinarSpeaker
              v-if="
                sessionDetails.status == 'Published' ||
                  sessionDetails.status == 'Draft'
              "
              :status="sessionDetails.status"
              :speaker_designation="sessionDetails.speaker_designation"
            />
            <WebinarTakeAway
              v-else
              :takeAway="sessionDetails.take_away"
              :dark="false"
              class="me-sm-4"
            />
          </v-col>
          <v-col cols="12" sm="4" align="right">
            <WebinarShare :sessionDetails="sessionDetails" :show_price="true" />
          </v-col>
        </v-row>
      </v-container>
      <div
        v-if="
          sessionDetails.status != 'Published' &&
            sessionDetails.status != 'Draft'
        "
        :class="
          $store.state.isMobile
            ? 'speaker-details-background-mobile pt-4'
            : 'speaker-details-background pt-4'
        "
      >
        <v-container>
          <WebinarSpeaker
            :speaker_details="sessionDetails.speaker_details"
            :status="sessionDetails.status"
            :speaker_designation="sessionDetails.speaker_designation"
          />
        </v-container>
      </div>
    </div>
    <RegisterNow :sessionDetails="sessionDetails" class="my-8" />
    <div>
      <v-container>
        <WhyEblityWebinar />
      </v-container>
    </div>
    <v-row id="webinar-section-3" class="ma-0">
      <v-col
        class="my-8"
        cols="12"
        align="center"
        style="font-weight: 500;font-size: 18px;line-height: 25px;color: #000000;"
      >
        Testimonials
      </v-col>
      <WebinarTestimonial />
    </v-row>
    <RegisterNow :sessionDetails="sessionDetails" class="my-8" />
    <v-row id="webinar-section-4" class="ma-0">
      <v-container>
        <WebinarFaqs />
      </v-container>
    </v-row>
    <v-row id="webinar-section-5" class="ma-0 mt-12" style="background:#fff">
      <v-container>
        <WebinarGroupsSkillsTags
          :ageGroup="sessionDetails.ageGroup"
          :skills="sessionDetails.skills"
          :tags="sessionDetails.tags"
        />
      </v-container>
    </v-row>
    <RegisterNow :sessionDetails="sessionDetails" class="my-8" />
  </div>
</template>

<script>
  import helper from "@/helper";

  import RegisterLoginCard from "../../../components/LoginRegister/RegisterLoginCard.vue";
  import RegisterNow from "./components/RegisterNow.vue";
  import WebinarTestimonial from "./components/WebinarTestimonial.vue";
  import WebinarFaqs from "./components/WebinarFaqs.vue";
  import WebinarTakeAway from "./components/WebinarTakeAway.vue";
  import WebinarShare from "./components/WebinarShare.vue";
  import WhyEblityWebinar from "./components/WhyEblityWebinar.vue";
  import WebinarSpeaker from "./components/WebinarSpeaker.vue";
  import WebinarGroupsSkillsTags from "./components/WebinarGroupsSkillsTags.vue";
  import AmplitudeHelper from "../../../amplitude";

  export default {
    name: "WebinarDetails",
    props: ["details"],
    components: {
      RegisterLoginCard,
      RegisterNow,
      WebinarTestimonial,
      WebinarFaqs,
      WebinarTakeAway,
      WebinarShare,
      WhyEblityWebinar,
      WebinarSpeaker,
      WebinarGroupsSkillsTags,
    },
    data() {
      return {
        display: false,
      };
    },
    created() {
      AmplitudeHelper.registerAmplitudeEvent("view webinar detail page", {
        "webinar name": this.details.title,
        "webinar type": this.details.status,
        tags: [...new Set(this.details.tags.map((element) => element.name))],
        skills: [
          ...new Set(this.details.skills.map((element) => element.name)),
        ],
        "age group": [
          ...new Set(this.details.age_groups.map((element) => element.name)),
        ],
      });

      this.$store.state.pageLocation = "webinar";
    },
    computed: {
      sessionDetails() {
        var session_list = [];

        this.details.session_list.forEach((element) => {
          session_list.push({
            title: element.session_title,
            dates: helper.formatDate(element.date) + " " + element.time,
            abstract: element.session_abstract,
            thumbnailPath: element.thumbnail_path ? element.thumbnail_path : "",
          });
        });

        return {
          id: this.details.id,
          headerImage: this.details.thumbnail_path,
          dateToFrom: this.getFormattedDate(),
          title: this.details.title,
          subTitle: this.details.sub_heading,
          take_away: this.details.take_aways,
          speaker_details: {
            educatorName: this.details.conductor_details.user_details
              ? this.details.conductor_details.user_details.name
              : "",
            educatorImage: this.details.speaker_image
              ? this.details.speaker_image
              : "",
            educatorBio: this.details.speaker_bio
              ? this.details.speaker_bio
              : "",
          },
          skills: this.details.skills,
          ageGroup: this.details.age_groups,
          tags: this.details.tags,
          price: this.details.amount,
          is_free: this.details.is_free,
          hostedBy: this.details.conductor_details.user_details
            ? this.details.conductor_details.user_details.name
            : "",
          sessionsList: session_list,
          offerAndPricing: {
            allSessions: {
              title: "All 3 Session",
              price: this.details.amount,
              abstract: [
                "Why communication is important for a child with DS?",
                "How to reduce the gap for communication development milestones?",
                "Why early intervention is critical?",
                "Strategies",
                "Resources",
              ],
            },
            individualSession: {
              title: "Individual Session",
              price: this.details.individual_amount,
              abstract: [
                "Why communication is important for a child with DS?",
                "Why communication is important for a child with DS?",
                "How to reduce the gap for communication development milestones?",
              ],
            },
            sessionList: session_list,
          },
          status: this.details.status, //On Demand, Scheduled, Published
          date: helper.formatDate(this.details.start_date_time),
          day: helper.getDay(this.details.start_date_time),
          time:
            helper.formatTime(new Date(this.details.start_date_time)) +
            ", " +
            helper.getTimezoneName(new Date(this.details.start_date_time)),
          sessions: this.details.session_list,
          is_bought: this.details.is_bought,
          is_requested: this.details.is_requested,
          speaker_designation: this.details.speaker_designation,
        };
      },
    },
    watch: {},
    methods: {
      getFormattedDate() {
        return (
          helper.formatDate(this.details.start_date_time) +
          " - " +
          helper.formatDate(this.details.end_date_time)
        );
      },
    },
    mounted() {
      AmplitudeHelper.registerEvent("Webinar - View", this.details);
    },
  };
</script>

<style scoped>
  .groups-skills-tags {
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    color: #333333;
  }

  .pending-webinar-section {
    background: #ffffff;
  }
  .speaker-details-background {
    /* background: radial-gradient(110% 50% at top, transparent 50%, lightblue 51%); */
    background: #ffffff;
    border-top-left-radius: 45%;
    border-top-right-radius: 45%;
  }
  .speaker-details-background-mobile {
    /* background: radial-gradient(110% 50% at top, transparent 50%, lightblue 51%); */
    background: #ffffff;
    border-top-left-radius: 0%;
    border-top-right-radius: 0%;
  }
</style>
